import React, { useState, useContext } from 'react';
import { View } from 'react-native';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';
import { getThemeImages } from '../../Themes';

import CardContent from './Components/CardContent';
import { DisplayContext } from './options.context';
import styles from './styles';

function DisplayOptions() {
  const { changeTheme, option } = useContext(DisplayContext);
  const [selected, setSelected] = useState(option);

  const handelOnPress = themeOption => {
    setSelected(themeOption);
    changeTheme(themeOption);
  };

  const theme = useTheme();
  const images = getThemeImages(theme.name);
  return (
    <>
      <View
        style={styles.containerStyle}
        testID={FrameworkTestKeys.settingsDisplayOptionsContainerView}
      >
        <Icon
          type="image"
          name={images.icHalfHashedCircle}
          size={34}
          testID={FrameworkTestKeys.settingsDisplayOptionsIcon}
        />
        <View
          style={styles.textContainerStyle}
          testID={FrameworkTestKeys.settingsDisplayOptionsTextView}
        >
          <VFText
            type="primary"
            i18nKey="display_options_display_mode_section_title"
            style={styles.titleStyle}
            testKey={FrameworkTestKeys.settingsDisplayOptionsTitleText}
          />
        </View>
      </View>

      <CardContent selected={selected} handelOnPress={handelOnPress} />

      <VFText
        type="primary"
        i18nKey="display_options_display_mode_section_description"
        style={styles.descriptionStyle}
        testKey={FrameworkTestKeys.settingsDisplayOptionsDescriptionText}
      />
    </>
  );
}

export default DisplayOptions;
